export function isPlayModeLocked(
  event: { playModeLockedAt?: string; requestsStartedAt?: string } | null | undefined,
): boolean {
  return Boolean(event?.playModeLockedAt || event?.requestsStartedAt);
}
